import { Action, configureStore, ThunkAction } from '@reduxjs/toolkit';
import baasSignupSlice from '../features/baasSignup/baasSignupSlice';
import languageSlice from '../features/language/languageSlice';
import sandboxSlice from '../features/sandbox/sandboxSlice';
import redirectErrorSlice from '../features/redirectError/redirectErrorSlice';
import messagesSlice from '../features/messages/messagesSlice';
import daasSignupSlice from '../features/daasSignup/daasSignupSlice';
import loginSlice from '../features/login/loginSlice';
import directSignupSlice from '../features/directSignup/directSignupSlice';
import hmiSlice from '../features/hmi/hmiSlice';
import signupSlice from '../features/signup/signupSlice';

export const store = configureStore({
  reducer: {
    baasSignup: baasSignupSlice,
    daasSignup: daasSignupSlice,
    directSignup: directSignupSlice,
    login: loginSlice,
    language: languageSlice,
    hmi: hmiSlice,
    sandbox: sandboxSlice,
    redirectError: redirectErrorSlice,
    messages: messagesSlice,
    signup: signupSlice,
  },
});

export type RootState = ReturnType<typeof store.getState>;
export type AppThunk<ReturnType = void> = ThunkAction<ReturnType, RootState, unknown, Action<string>>;
